"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fonts = exports.Colors = void 0;
var Colors = {
    C1: { themeName: 'color_11', reference: 'color-1' },
    C5: { themeName: 'color_15', reference: 'color-5' },
    C8: { themeName: 'color_18', reference: 'color-8' },
    CB: { themeName: 'color_2', reference: 'black/white' },
};
exports.Colors = Colors;
var Fonts = {
    Paragraph2: { preset: 'Body-M', editorKey: 'font_8' },
    Heading5: { preset: 'Heading-M', editorKey: 'font_5' },
};
exports.Fonts = Fonts;
//# sourceMappingURL=constants.js.map